<template>
  <v-card class="mt-3 pa-3" style="margin: 15px">
    <form class="formulario" @submit.prevent="gerarRelatorio">
      <div>
        <Select label="Ano" :options="optionsAno" v-model.number="aaletivo" :v="$v.aaletivo" :disabled="loading" @change="limparSelects()" />

        <select-ajax
          label="Turma"
          :disabled="loading || aaletivo == '-1'"
          rota='ei/turma/por-perfil-ano-disciplina-periodo-professor'
          :params="{ cdtipesc, cdescola, cdpessoal:cdpessoalautor, cdmatric:cdmatricautor, aaletivo, cddiscipl, cdpessoalprofessor, cdmatricprofessor, cdpravadi, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          contador
          opcaoTodos="Todas"
          ref="turmas"
          chave="cdturma"
          :valor="(item) => `${item.nmturma} ${item.horario ? ' - ' + item.horario : ''}`"
          v-model="cdturma"
          :v="$v.cdturma"
          >
        </select-ajax>

        <select-ajax
          label="Disciplina/Campo de Experiência"
          :disabled="loading"
          rota='ei/disciplina/por-perfil-ano-turma-periodo-professor'
          :params="{ aaletivo, cdtipesc, cdescola, cdpessoal:cdpessoalautor, cdmatric:cdmatricautor, cdturma, cdpessoalprofessor, cdmatricprofessor, cdpravadi, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          opcaoTodos="Todas"
          contador
          ref="disciplinas"
          chave="cddiscipl"
          valor="dsdiscipl"
          v-model="cddiscipl"
          :v="$v.cddiscipl"
          >
        </select-ajax>

        <select-ajax
          label="Professor"
          :disabled="loading"
          rota='ei/professor/por-perfil-ano-turma-disciplina-periodo'
          :params="{ aaletivo, cdpessoal:cdpessoalautor, cdmatric:cdmatricautor, cdtipesc, cdescola, cdturma, cddiscipl, cdpravadi, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          opcaoTodos="Todos"
          contador
          ref="professores"
          :chave="(item) => `${item.cdpessoal}-${item.cdmatric}`"
          :valor="(item) => `${item.cdmatric} - ${item.nmfuncion}`"
          v-model="professor"
          :v="$v.cdmatricprofessor">
        </select-ajax>

        <Select :label="`Situação (${ optionsSituacoes.length })`" :disabled="loading" :options="optionsSituacoes" v-model="indicasituacaonotificacao" :v="$v.indicasituacaonotificacao" />

        <select-ajax
          label="Período Avaliativo"
          :disabled="loading"
          rota='ei/periodo-avaliativo/periodos-por-coordenador-ano-turma-disciplina-professor'
          :params="{ aaletivo, cdtipesc, cdescola, cdpessoal:cdpessoalautor, cdmatric:cdmatricautor, cdturma, cddiscipl, cdpessoalprofessor, cdmatricprofessor, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          contador
          opcaoTodos="Todos"
          ref="periodos"
          chave="cdpravadi"
          valor="dspravadi"
          v-model="cdpravadi"
          :v="$v.cdpravadi">
        </select-ajax>

      </div>

      <div style="text-align: right">
        <v-btn width="120px" class="rounded-sm font-weight-regular" type="submit" color="teal" style="color:white" :disabled="loading" :loading="loadingGerar">
          <v-icon size="23" left dark>picture_as_pdf</v-icon>
          Gerar
        </v-btn>
      </div>

    </form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, integer, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import notificacoesReport from '@/reports/coordenador/notificacoesReport';
import SelectAjax from '@/components/SelectAjax'

const CoordenadorReportsRepository = RepositoryFactory.get('coordenadorReports');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'RelatorioNotificacoes',
  components: {
    SelectAjax
  },
  data() {
    return {
      cdpessoalautor: '',
      cdmatricautor: '',
      aaletivo: '',
      cdpessoal: '',
      cdmatric: '',
      cdtipesc: '',
      cdescola: '',
      cdturma: '',
      cddiscipl: '',
      cdpravadi: '',
      cdpessoalprofessor: '',
      cdmatricprofessor: '',
      indicasituacaonotificacao: '-1',
      optionsSituacoes: [
        { value: '-1', text: 'Todas'},
        { value: 'P', text: 'Pendente'},
        { value: 'R', text: 'Respondido'}
      ],
      loading: false,
      loadingGerar: false,
    };
  },
  validations() {
    return {
      aaletivo: { required, integer },
      cdtipesc: { required, integer },
      cdescola: { required, integer },
      cdpessoal: { required, integer },
      cdmatric: { required, integer },
      cdturma: { maxLength: maxLength(4) },
      cddiscipl: { integer },
      cdpravadi: { maxLength: maxLength(2) },
      cdpessoalprofessor: { integer },
      cdmatricprofessor: { integer },
      indicasituacaonotificacao: {},
    };
  },
  async created() {
    this.cdpessoalautor = this.userProfessor.cdpessoal;
    this.cdmatricautor = this.userProfessor.cdmatric;
    this.aaletivo = this.getAnoAtualServidor;
    this.cdtipesc = this.school.cdtipesc;
    this.cdescola = this.school.cdescola;
    this.cdpessoal = this.userProfessor.cdpessoal;
    this.cdmatric = this.userProfessor.cdmatric;
  },
  methods: {
    async gerarRelatorio() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      this.loadingGerar = true;

      try {

        const { data } = await CoordenadorReportsRepository.getNotificacoes({
          aaletivo: this.aaletivo,
          cdtipesc: this.cdtipesc,
          cdescola: this.cdescola,
          cdpessoal: this.cdpessoalautor,
          cdmatric: this.cdmatricautor,
          cdturma: this.cdturma,
          cddiscipl: this.cddiscipl,
          cdpessoalprofessor: this.cdpessoalprofessor,
          cdmatricprofessor: this.cdmatricprofessor,
          indicasituacaonotificacao: this.indicasituacaonotificacao,
          cdpravadi: this.cdpravadi
        });

        const filtros = {
            aaletivo: this.aaletivo,
            cdtipesc: this.cdtipesc,
            cdescola: this.cdescola,
            cdpessoal: this.cdpessoalautor,
            cdmatric: this.cdmatricautor,
            nmfuncion: this.username,
            nmescola: this.school.nmescola,
            identificadorperfil: this.userDadosPerfilAtual.identificadorperfil,
        };

        const docDefinition = await notificacoesReport({
          date: data.results.date,
          time: data.results.time,
          filtros,
          data: data.results.data
        });

        pdfMake.createPdf(docDefinition).download(docDefinition.info.title);

      } finally {
        this.loadingGerar = false;
      }
    },

    limparSelects() {
      this.$refs.turmas.limpar();
      this.$refs.disciplinas.limpar();
      this.$refs.professores.limpar();
      this.indicasituacaonotificacao = '-1';
      this.$refs.periodos.limpar();
    }
  },
  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username', 'userDadosPerfilAtual']),
    optionsAno() {
      if(!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }
      let retornoOptions = [];
      for(let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
    professor: {
      get() {
        return this.cdmatricprofessor == -1 ? this.cdmatricprofessor : `${this.cdpessoalprofessor}-${this.cdmatricprofessor}`;
      },
      set(value) {
        if (value === -1 || value === "") {
          this.cdpessoalprofessor = '';
          this.cdmatricprofessor = value;
          return;
        }
        [this.cdpessoalprofessor, this.cdmatricprofessor] = value.split('-');
      }
    }
  },
}
</script>

<style lang="scss">
@media only screen and (min-width: 700.1px){
  .formulario .select-ajax {
    .selecionado { width: 60%; }
    .select-ajax-lista { width: 60%; }
  }
}
</style>
